import React from 'react';
import styles from './ImageModal.module.css';

interface ImageModalProps {
  src: string;
  alt?: string;
  onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ src, alt = '', onClose }) => (
  <div className={styles.imageModalOverlay} onClick={onClose}>
    <div className={styles.imageModal} onClick={e => e.stopPropagation()}>
      <img src={src} alt={alt} className={styles.imageModalImg} />
      <button className={styles.imageModalClose} onClick={onClose}>&times;</button>
    </div>
  </div>
);

export default ImageModal;
